<div class="loginWrap">

    <div class="leftPanel">
        <h2>Welcome to<br/>rail e-learning</h2>
        <div class="loginNav">
            <a href="javascript:void(0);" [routerLink]="['/privacy']">Privacy Policy</a>
            <a href="javascript:void(0);" [routerLink]="['/terms']">Terms of Services</a>
            <a href="javascript:void(0);" [routerLink]="['/contact_us']">Contact Us</a>
        </div>
    </div>
    <input type="hidden" (click)="open1(accountValidation)" id="AcoountValidation">
    <div class="rightPanel">
        <div class="loginContent">
            <h1 [routerLink]="['/']"><img src="assets/images/logo.svg" /> </h1>
            <div class="roleWrap">
                <h3>Login</h3>
                <div class="roleSelect">
                    <mat-radio-group aria-label="Select an option" [formControl]="rdoUserTyp">
                        <mat-radio-button value="1" [routerLink]="['/']">As User</mat-radio-button>
                        <mat-radio-button value="2" [routerLink]="['/admin-login']">As Admin</mat-radio-button>
                    </mat-radio-group>
                    <!-- <label class="customRadio"><input type="radio" checked name="login" /><i></i><span>As User</span></label>
                    <label class="customRadio"><input type="radio" name="login" /><i></i><span>As Admin</span></label> -->
                </div>
            </div>
            <form [formGroup]="loginForm">
                <div class="form-group">
                    <label class="loginTitle">Email ID</label>
                    <input type="email" class="form-control" formControlName="email" id="exampleInputEmail" aria-describedby="emailHelp" placeholder="Enter Email ID" [ngClass]="{ 'is-invalid': submitted && f.email.errors }" >
                    <div *ngIf="submitted && f.email.errors">
                        <span *ngIf="f.email.errors.required" class="text-mute text-danger errorText">This field is required</span>
                        <span *ngIf="f.email.errors.pattern" class="text-mute text-danger errorText">Please provide a valid email address</span>
                    </div>
                </div>
                <div class="form-group">
                    <label class="loginTitle">Password</label>
                  <input type="password" class="form-control" formControlName="password" id="exampleInputPassword" placeholder="Enter Password" [ngClass]="{ 'is-invalid': submitted && f.email.errors }" [type]="hide ? 'password':'text'">
                  <i class="iconEye" [class]="hide ? 'iconEye':'iconEye active'"  (click)="hide =!hide"></i> 
                  <div *ngIf="submitted && f.password.errors">
                    <span *ngIf="f.password.errors.required" class="text-mute text-danger errorText">This field is required</span>
                </div>
                <div *ngIf="errorInfo.isError">
                    <span class="text-mute text-danger errorText">{{ errorInfo.errorMsg}}</span>
                </div>
                </div>
                <div class="forgot">
                    <a href="javascript:void(0);"  (click)="goToForgot()">Forgot Password?</a>
                </div>
                
                <!-- <button type="submit" class="btn btn-primary" (click)="open(acntTypMdl) ">Login</button> -->
                <button type="submit" class="btn btn-primary" (click)="loginUser(loginForm.value)">Login</button>
              
              </form>
        </div>
        <div class="beforeContact">
            Do not have login and wish to get one?  <a href="javascript:void(0);" [routerLink]="['/contact_us']">Contact us</a> with your details
        </div>
    </div>
    <ngx-spinner>
        <p style="color: white"> Loading... </p>
    </ngx-spinner>
    <div class="loginNav mobileNave">
        <a href="javascript:void(0);" [routerLink]="['/privacy']">Privacy Policy</a>
        <a href="javascript:void(0);" [routerLink]="['/terms']">Terms of Services</a>
        <a href="javascript:void(0);" [routerLink]="['/contact_us']">Contact Us</a>
    </div>
</div>
<ng-template #accountValidation let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <p class="size18">Your Account has been expired . Please cantact to administrator</p>
                <input type="hidden" (click)="modal.dismiss('Save click')" id="CloseIds">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">OK</a>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #acntTypMdl let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>Choose the below option for login</h6>
                <p class="size18">Do you want to login as</p>

                <!-- <mat-form-field class="example-full-width">
                    <mat-label>Enter OTP</mat-label>
                    <input matInput [formControl]="txtOtp" autocomplete="off">
                </mat-form-field>  -->
                <mat-radio-group aria-label="Select an option" [formControl]="rdoUserTyp">
                    <mat-radio-button value="1">User</mat-radio-button>
                    <mat-radio-button value="2">Admin</mat-radio-button>
                </mat-radio-group>
               
            </div>
            <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">No,
                cancel</a>
            <a href="javascript:void(0);" class="btn btn-primary btn-sm" (click)="loginUser(loginForm.value)">Submit</a>
            <input type="hidden" (click)="modal.dismiss('Cross click')" id="closelId">
        </div>
    </div>
</ng-template>
